<template>
  <div class="module_list_1">
    <div class="row">
      <div
        class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
        v-for="item in modulelist"
        :key="item.id"
      >
        <div class="module_item_1" @click="goproductDetail(item.id)">
          <div class="mo_icon">
            <img :src="item.iconpath" />
          </div>
          <div class="mo_info">
            <div class="mo_title">{{ item.title }}</div>
            <div class="mo_desc">{{ item.subtitle }}</div>
            <div class="mo_price"><i>￥</i>{{ item.show_price }}</div>
          </div>
          <div class="mo_btn">点击查看</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modulelist"],
  data() {
    return {};
  },
  methods: {
    goproductDetail(id) {
      this.$router.push({
        path: "productdetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
[class*="col-"] {
  padding: 0 0.05rem;
}
.row {
  margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/modulelist1.vue